import React, { useState } from "react";
import { Briefcase, Settings, Zap, AppWindow, Wifi, Phone, X } from "lucide-react";
import logo from "./assets/RegelIT logo.png"; // Zorg dat je logo hier staat

const services = [
    {
      id: "o365",
      icon: <Briefcase className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "Office 365 & Excel ondersteuning",
      short: "Problemen met mailboxen? Werkt je Teams of SharePoint niet zoals je wil? Of worstel je met omslachtige Excel-tabellen? Wij zorgen dat alles opnieuw werkt — en beter dan ooit.",
      long: "Haal het maximale uit je Office 365-abonnement! We regelen alles wat erbij komt kijken: e-mailconfiguratie, mailboxmigraties, permissiebeheer in SharePoint of Teams die moeten samenwerken. Daarnaast zijn we sterk in Excel: of je nu eenvoudige facturen maakt of draaitabellen en Power Query gebruikt (Wat is dat?), wij bouwen mee aan duidelijke, betrouwbare worksheets die je tijd besparen in plaats van kosten."
    },
    {
      id: "automatisatie",
      icon: <Settings className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "Slimme automatisatie van kantoortaken",
      short: "Krijg je elke week dezelfde mails binnen? Keur je manueel documenten goed? Wij zetten die processen op automatische piloot met gebruiksvriendelijke flows.",
      long: "Tijdrovende handelingen? Wij regelen dat voor jou. Denk aan meldingen die automatisch verzonden worden, documenten die zichzelf opslaan op de juiste plek of goedkeuringen die vanzelf doorstromen. We zetten jouw werkprocessen op automatische piloot met Power Automate — zodat jij minder moet klikken, nadenken of wachten."
    },
    {
      id: "ai",
      icon: <Zap className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "AI zonder buzzwords",
      short: "AI kan je écht helpen — als je weet waar het past. Wij tonen je concrete toepassingen: van e-mailanalyse tot automatisch rapporteren of tekst samenvatten.",
      long: "AI is geen tovertruc. Wij regelen dat het écht voor je werkt. Denk aan automatische samenvattingen van vergaderingen, het herkennen van klantvragen via e-mail of slimme rapporten die zichzelf updaten. Geen buzzwords — wel praktische toepassingen die je vandaag al kan gebruiken."
    },
    {
      id: "powerapps",
      icon: <AppWindow className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "PowerApps op maat",
      short: "Heb je een eigen formulier, interne tool of klantenoverzicht nodig? Wij bouwen apps die jouw werking ondersteunen — zonder overbodige complexiteit.",
      long: "Werk je nog met Excel-lijsten, post-its of verouderde software? Wij regelen een app op maat die jouw processen digitaliseert. Denk aan registraties, checklists, opvolging of interne tools. Alles netjes in één app, afgestemd op jouw werkwijze, zonder onnodige toeters en bellen."
    },
    {
      id: "netwerk",
      icon: <Wifi className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "Netwerk & WiFi installatie",
      short: "Trage verbinding? Slecht bereik? Wij zorgen voor een stabiel netwerk, afgestemd op je kantoor, magazijn of praktijk.",
      long: "Niets zo frustrerend als wegvallend internet of apparaten die elkaar niet vinden. Wij regelen een stabiele netwerkinfrastructuur, inclusief slimme WiFi, switches en bekabeling waar nodig. Je merkt het verschil vanaf dag één — op kantoor, in de praktijk of het magazijn."
    },
    {
      id: "voip",
      icon: <Phone className="text-[#00b0dc] w-8 h-8 mb-3" />,
      title: "Voice over IP telefonie",
      short: "Je vaste lijn op je gsm? Of centrale voor je team?",
      long: "Telefonie zoals jij dat wil. We regelen een VoIP-systeem waarmee je oproepen ontvangt op je GSM, via je laptop of een vaste lijn. Professioneel bereikbaar, flexibel instelbaar én klaar voor groei — zonder dure centrale of ingewikkeld beheer."
    }
  ];


export default function HomePage() {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState('');
    const [selectedService, setSelectedService] = useState(null);
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setSending(true);
      setStatus('');
      try {
        const response = await fetch('ml/contact.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });
        if (response.ok) {
          setStatus('Bedankt! Uw bericht is verzonden.');
          setFormData({ name: '', email: '', message: '' });
        } else {
          const text = await response.text();
          setStatus(text || 'Er ging iets mis.');
        }
      } catch (err) {
        setStatus('Er ging iets mis bij het verzenden.');
      } finally {
        setSending(false);
      }
    };
  
    return (
      <main className="min-h-screen bg-gradient-to-b from-white via-gray-50 to-[#eaf9fd] text-gray-900 font-sans">
        {/* Navigatie */}
        <header className="flex items-center justify-between px-6 py-4 shadow-md sticky top-0 bg-white z-50">
          <div className="flex items-center space-x-3">
            <img src={logo} alt="RegelIT logo" className="h-10 w-auto" />
            <span className="text-xl font-bold text-gray-800">
              Regel<span className="text-[#00b0dc]">IT</span>
            </span>
          </div>
          <nav className="space-x-6 hidden md:block">
            <a href="#services" className="text-gray-700 hover:text-[#00b0dc] font-medium transition">Diensten</a>
            <a href="#approach" className="text-gray-700 hover:text-[#00b0dc] font-medium transition">Aanpak</a>
            <a href="#about" className="text-gray-700 hover:text-[#00b0dc] font-medium transition">Over ons</a>
            <a href="#contact" className="text-gray-700 hover:text-[#00b0dc] font-medium transition">Contact</a>
          </nav>
        </header>
  
        {/* Hero sectie */}
        <section className="py-28 px-6 text-center relative overflow-hidden">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[800px] h-[800px] bg-[#00b0dc]/10 rounded-full blur-3xl -z-10"></div>
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight">
            IT die werkt.<br className="hidden md:block" /> Zodat jij dat niet hoeft te doen.
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto text-gray-700">
            Bij RegelIT regelen we jouw IT: zonder zorgen, zonder complexiteit. Gewoon technologie die doet wat jij nodig hebt.
          </p>
          <div className="mt-10 animate-bounce">
            <a
              href="#services"
              className="inline-block bg-[#00b0dc] text-white px-8 py-4 rounded-full text-lg shadow-md hover:bg-[#009ac2] transition"
            >
              Ontdek onze diensten
            </a>
          </div>
        </section>
  
        {/* Aanpak */}
        <section id="approach" className="bg-[#f3fbfd] py-24 px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Hoe wij werken</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              Geen standaardpakket. Geen aannames. Bij RegelIT starten we met één simpele stap: <strong>we komen gratis eens meewandelen</strong>. We leren je processen kennen, observeren je team, en ontdekken waar IT echt het verschil kan maken. 
              <br /><br />
              IT-oplossingen moeten zich aanpassen aan jouw bedrijf — niet omgekeerd. Wij bouwen op maat, zodat je efficiënter werkt zonder je gewoontes te moeten omgooien.
            </p>
          </div>
        </section>
  
        {/* Over ons sectie */}
        <section id="about" className="bg-[#f3fbfd] py-24 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Wie zijn wij?</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              RegelIT is een kleinschalig IT-bedrijf dat grote impact maakt. Wij geloven dat technologie geen struikelblok mag zijn, maar een kracht die ondernemers vooruit helpt. Daarom bieden we oplossingen die helder, doelgericht en betaalbaar zijn — met persoonlijke service en heldere communicatie.
            </p>
          </div>
        </section>

      <section id="services" className="bg-white py-24 px-6">
      <h2 className="text-3xl font-bold text-center mb-16">Onze diensten</h2>
      <div className="relative max-w-7xl mx-auto overflow-hidden">
        {/* Dienstkaarten links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-12 pb-12"> 
          {services.map((service) => (
            <div
            key={service.id}
            onClick={() => { setSelectedService(service); const el = document.getElementById('services'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
            className={`cursor-pointer bg-white p-6 rounded-3xl shadow-md border hover:shadow-xl transition text-center hover:bg-[#f0faff] ${
              selectedService?.id === service.id ? 'ring-2 ring-[#00b0dc]' : ''
            }`}
          >
              {service.icon}
              <h3 className="text-xl font-semibold mb-2 text-[#00b0dc]">{service.title}</h3>
              <p className="text-gray-700 text-sm">{service.short}</p>
            </div>
          ))}
        </div>

        {/* Detailpaneel rechts */}
        {selectedService && (
          <div className="absolute top-0 right-0 w-full lg:w-1/2 h-full bg-[#f9feff] p-10 shadow-lg overflow-auto z-20">
            <button
              className="absolute top-6 right-6 text-gray-500 hover:text-black"
              onClick={() => setSelectedService(null)}
            >
              <X />
            </button>
            <h3 className="text-2xl font-bold text-[#00b0dc] mb-4 mt-2">{selectedService.title}</h3>
            <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">{selectedService.long}</p>
            <div className="mt-6">
              <button
                className="bg-[#00b0dc] text-white px-6 py-3 rounded-full hover:bg-[#009ac2] transition"
                onClick={() => window.scrollTo({ top: document.getElementById('contact').offsetTop, behavior: 'smooth' })}
              >
                Vraag meer info aan
              </button>
            </div>
          </div>
        )}
      </div>
    </section>


       {/* Contact sectie */}
       <section id="contact" className="bg-white py-24 px-6 border-t text-center">
        <h2 className="text-3xl font-bold mb-8">Neem contact op</h2>
        <p className="text-gray-700 mb-6">
          Heb je vragen of wil je samenwerken? Stuur ons een bericht. We nemen snel contact op.
        </p>
        <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4 text-left">
  <div>
    <label htmlFor="name" className="block text-gray-700 mb-1">Naam</label>
    <input
      type="text"
      id="name"
      name="name"
      value={formData.name}
      onChange={handleChange}
      required
      className="w-full px-4 py-2 border rounded-xl"
    />
  </div>
  <div>
    <label htmlFor="email" className="block text-gray-700 mb-1">E-mailadres</label>
    <input
      type="email"
      id="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
      className="w-full px-4 py-2 border rounded-xl"
    />
  </div>
  <div>
    <label htmlFor="message" className="block text-gray-700 mb-1">Bericht</label>
    <textarea
      id="message"
      name="message"
      rows="5"
      value={formData.message}
      onChange={handleChange}
      required
      className="w-full px-4 py-2 border rounded-xl"
    />
  </div>
  <button
    type="submit"
    disabled={sending}
    className="bg-[#00b0dc] text-white px-6 py-3 rounded-full hover:bg-[#009ac2] transition disabled:opacity-50"
  >
    {sending ? 'Verzenden...' : 'Verstuur bericht'}
  </button>
  {status && <p className="mt-4 text-center text-sm text-gray-700">{status}</p>}
</form>
      </section>

      {/* Footer */}
      <footer className="bg-[#111111] text-white py-12 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="text-xl font-bold mb-2">RegelIT</h3>
            <p>BTW BE0628.746.278</p>
            <p>Maastrichterstraat 272</p>
            <p>3740 Waltwilder</p>
          </div>
          <div className="text-md md:text-right">
            <button
              onClick={() => setShowDisclaimer(true)}
              className="underline text-[#00b0dc] hover:text-white transition"
            >
              Disclaimer
            </button>
          </div>
        </div>

        {showDisclaimer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white text-black rounded-xl p-8 max-w-lg w-full relative">
              <h4 className="text-xl font-semibold mb-4">Disclaimer</h4>
              <p className="text-sm leading-relaxed">
                De informatie op deze website is met de grootste zorg samengesteld. RegelIT is niet verantwoordelijk voor enige directe of indirecte schade die zou kunnen ontstaan door het gebruik van deze informatie.
              </p>
              <button
                onClick={() => setShowDisclaimer(false)}
                className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
              >
                ×
              </button>
            </div>
          </div>
        )}
      </footer>
    </main>
  );
}